// extracted by mini-css-extract-plugin
module.exports = {"logo":"Protected_logo__3nmu9","password":"Protected_password__341oA","requestPassword":"Protected_requestPassword__i9nu0"};